import { atom, useAtomValue } from 'jotai';

import { rawSnapshotSpecAtom } from '../snapshot/state';
import { resolveDisplayQuoteCurrencies } from './utils';

/**
 * 마켓이 노출할 quote currency 목록의 단일 출처.
 * 사용자에게 통화 목록을 보여주는 곳(마켓 캐러셀 설명, VIP 티어 승급 조건)은 여기서 읽는다.
 *
 * 큐레이션 목록 + 실제 상장의 AND 조건이다 — 마켓 탭·캐러셀 카드와 동일한 게이트를 쓴다.
 * 판정 규칙은 `resolveDisplayQuoteCurrencies` 참고.
 *
 * `snapshotSpecBunja` 대신 `rawSnapshotSpecAtom` 을 쓴다:
 * bunja 버전은 pswapsBunja/marketsBunja(소켓)를 끌어오지만 `pswapInstruments` 는 raw 를
 * 그대로 통과시키므로(state.ts 의 snapshotSpecAtom 은 spotInstruments/instrumentsKeyBySymbol 만 덮어씀)
 * 얻는 값이 동일하다. 통화 라벨 하나 때문에 마케팅 페이지에 소켓 구독을 붙일 이유가 없다.
 */
const displayQuoteCurrenciesAtom = atom((get) =>
  resolveDisplayQuoteCurrencies(get(rawSnapshotSpecAtom)?.pswapInstruments ?? []),
);

export function useDisplayQuoteCurrencies(): string[] {
  return useAtomValue(displayQuoteCurrenciesAtom);
}
